export const theme = {
  colors: {
    primary: "#233E58",
    background: "#F7F9FB",
    accent: "#51C4D3",
    surface: "#FFF",
    text: "#131A22",
  },
  fonts: {
    main: "Inter, Arial, sans-serif"
  }
};